// extracted by mini-css-extract-plugin
export default {"container":"styles_container__lq6Gq","header":"styles_header__91BRN","row":"styles_row__00La6","center":"styles_center__FEYPN"};